const MODULE_NAME = 'SYSTEM_STUDIES';
const SYSTEM_STUDIES_FETCH_STARTED = MODULE_NAME + 'FETCH_STARTED';
const SYSTEM_STUDIES_FETCH_COMPLETED = MODULE_NAME + 'FETCH_COMPLETED';
const SYSTEM_STUDY_DELETE_STARTED = MODULE_NAME + 'DELETE_STARTED';
const SYSTEM_STUDY_DELETE_COMPLETED = MODULE_NAME + 'DELETE_COMPLETED';
const SYSTEM_STUDY_SET_DIRTY = MODULE_NAME + 'SET_DIRTY';

export {
  SYSTEM_STUDIES_FETCH_STARTED,
  SYSTEM_STUDIES_FETCH_COMPLETED,
  SYSTEM_STUDY_DELETE_STARTED,
  SYSTEM_STUDY_DELETE_COMPLETED,
  SYSTEM_STUDY_SET_DIRTY
};
